import { FileText } from "lucide-react";
import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";
import { ApprovalFormPreview } from "./ApprovalFormPreview";

const shifts = [
  { code: "00_08", label: "VR1", hours: "00:00–08:00" },
  { code: "08_16", label: "VR2", hours: "08:00–16:00" },
  { code: "16_00", label: "VR3", hours: "16:00–00:00" },
] as const;
const dateFormat = new Intl.DateTimeFormat("tr-TR", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" });

export function ApprovalShiftPreviews({ items, busy, onOpen }: {
  items: ShiftProductionFormListItem[];
  busy: boolean;
  onOpen: (id: string) => void;
}) {
  const dates = new Map<string, ShiftProductionFormListItem[]>();
  for (const item of items) {
    const date = item.productionDate ?? "";
    const forms = dates.get(date) ?? [];
    forms.push(item);
    dates.set(date, forms);
  }
  return [...dates].sort(([left], [right]) => right.localeCompare(left)).map(([date, forms]) => {
    const dateLabel = date ? dateFormat.format(new Date(`${date}T12:00:00Z`)) : "Tarih belirtilmedi";
    const unknownShift = forms.filter(item => !item.shift);
    return <section className="approval-date-group" key={date} aria-label={dateLabel}>
      <header><time dateTime={date || undefined}>{dateLabel}</time></header>
      <div className="approval-shift-grid">
        {shifts.map(shift => {
          const matching = forms.filter(item => item.shift === shift.code);
          return <section className="approval-shift-slot" key={shift.code} aria-label={`${dateLabel} ${shift.label}`}>
            <header><strong>{shift.label}</strong><span>{shift.hours}</span></header>
            {matching.length ? matching.map(item => <ApprovalFormPreview key={item.id} item={item} showShift={false} disabled={busy} onOpen={onOpen} />)
              : <div className="approval-shift-empty"><FileText size={24} strokeWidth={1.5} aria-hidden="true" /><strong>Bekleyen form yok</strong><span>Bu onay kuyruğunda</span></div>}
          </section>;
        })}
      </div>
      {unknownShift.length ? <section className="approval-unknown-shift" aria-label="Vardiyası belirtilmeyen formlar"><h5>Vardiya belirtilmedi</h5><div className="approval-form-previews">{unknownShift.map(item => <ApprovalFormPreview key={item.id} item={item} disabled={busy} onOpen={onOpen} />)}</div></section> : null}
    </section>;
  });
}
